import * as React from "react";

export interface LongNameComponentProps {
    name: string;
}

export const LongNameComponent = (props: LongNameComponentProps) => (
    <span title={props.name}>{props.name.length > 30 ? props.name.slice(0, 30) + "..." : props.name}</span>
);
